"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MarkdownHelp = function MarkdownHelp() {
  return _react2.default.createElement(
    "div",
    { className: "markhelp", style: { display: "none" } },
    _react2.default.createElement(
      "p",
      null,
      "reddit uses a slightly-customized version of",
      " ",
      _react2.default.createElement(
        "a",
        { href: "http://daringfireball.net/projects/markdown/syntax" },
        "Markdown"
      ),
      " ",
      "for formatting. See below for some basics, or check",
      " ",
      _react2.default.createElement(
        "a",
        { href: "/wiki/commenting" },
        "the commenting wiki page"
      ),
      " ",
      "for more detailed help and solutions to common issues."
    ),
    _react2.default.createElement(
      "table",
      { className: "md" },
      _react2.default.createElement(
        "tbody",
        null,
        _react2.default.createElement(
          "tr",
          {
            style: {
              backgroundColor: "#ffff99",
              textAlign: "center"
            }
          },
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "em",
              null,
              "you type:"
            )
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "em",
              null,
              "you see:"
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            "*italics*"
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "em",
              null,
              "italics"
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            "**bold**"
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "b",
              null,
              "bold"
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            "[reddit!](https://reddit.com)"
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "a",
              { href: "https://reddit.com" },
              "reddit!"
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            "* item 1",
            _react2.default.createElement("br", null),
            "* item 2",
            _react2.default.createElement("br", null),
            "* item 3"
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "ul",
              null,
              _react2.default.createElement(
                "li",
                null,
                "item 1"
              ),
              _react2.default.createElement(
                "li",
                null,
                "item 2"
              ),
              _react2.default.createElement(
                "li",
                null,
                "item 3"
              )
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            "> quoted text"
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "blockquote",
              null,
              "quoted text"
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            "Lines starting with four spaces",
            _react2.default.createElement("br", null),
            "are treated like code:",
            _react2.default.createElement("br", null),
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "span",
              { className: "spaces" },
              "\xA0\xA0\xA0\xA0"
            ),
            "if 1 * 2 != 3:",
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "span",
              { className: "spaces" },
              "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0"
            ),
            "print \"hello, world!\"",
            _react2.default.createElement("br", null)
          ),
          _react2.default.createElement(
            "td",
            null,
            "Lines starting with four spaces",
            _react2.default.createElement("br", null),
            "are treated like code:",
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "pre",
              null,
              "if 1 * 2 != 3:",
              _react2.default.createElement("br", null),
              "\xA0\xA0\xA0\xA0print \"hello, world!\"",
              "\n"
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            "~~strikethrough~~"
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "strike",
              null,
              "strikethrough"
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            "super^script"
          ),
          _react2.default.createElement(
            "td",
            null,
            "super",
            _react2.default.createElement(
              "sup",
              null,
              "script"
            )
          )
        )
      )
    )
  );
};

exports.default = MarkdownHelp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/MarkdownHelp.js
// module id = 195
// module chunks = 0